;(function () {

  // Ajax routes need the market root, or Shopify answers in the default market. routes.root ends in '/'.
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
  }
  const root = document.querySelector('[data-atb-notification]')
  if (!root) return

  const els = {
    image:    root.querySelector('[data-atb-notification-image]'),
    title:    root.querySelector('[data-atb-notification-title]'),
    price:    root.querySelector('[data-atb-notification-price]'),
    compare:  root.querySelector('[data-atb-notification-compare]'),
    progress: root.querySelector('[data-atb-notification-progress]'),
  }

  // announce/error are siblings of root (outside inert container) — §4.7
  const announce = document.querySelector('[data-atb-notification-announce]')
  const errorEl  = document.querySelector('[data-atb-notification-error]')
  const header   = document.querySelector('[data-header]')
  const group    = document.querySelector('[data-header-group]')
  const strings  = window.atbNotificationStrings || {}
  const DWELL    = 4000
  let dismissTimer = null

  // cart.js prices are integer cents; no preformatted string (L-ATB2). Prefer the market-aware formatter
  // (broraVoyado.formatMoney parses the ACTIVE market's money format) so non-GBP markets show the right
  // symbol/format — window.moneyFormat is shop.money_format (base GBP), which would stamp a £ on e.g. a PLN
  // value. Fall back to the base format (exact on the GBP base market) only when it isn't available.
  function formatMoney(cents) {
    const bv = window.broraVoyado
    if (bv && typeof bv.formatMoney === 'function') {
      // Pass the active market's ISO code (not bv.currencyCode, which is only set once the price
      // corrector has run) so the D85 code suffix (USD, AED…) matches the cards and the checkout.
      const code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || bv.currencyCode
      const out = bv.formatMoney((Number(cents) || 0) / 100, code)
      if (out) return out
    }
    const amount = (Number(cents) || 0) / 100
    const active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
    if (active) {
      try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: active }).format(amount) } catch (e) { /* unknown code */ }
    }
    const fmt = window.moneyFormat || '{{amount}}'
    const value = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value)
  }

  // HTML variant carrying the AED dirham glyph (voyado-price-storefront.js exposes it), else the plain
  // text. For the price/compare only — static markup + a numeric amount, so innerHTML is safe.
  function formatMoneyHtml(cents) {
    const bv = window.broraVoyado
    if (bv && typeof bv.formatMoneyHtml === 'function') {
      const code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || bv.currencyCode
      const out = bv.formatMoneyHtml((Number(cents) || 0) / 100, code)
      if (out) return out
    }
    return formatMoney(cents)
  }

  function resolveVariantId(e) {
    if (e.detail && e.detail.variantId) return String(e.detail.variantId)
    const ctx = e.target && e.target.closest && e.target.closest('[data-main-product]')
    const input = ctx && ctx.querySelector('[data-variant-id]')
    return input ? String(input.value) : null
  }

  function populate(cart, variantId) {
    const items = cart.items || []
    let item = variantId ? items.find(i => String(i.variant_id) === variantId) : null
    if (!item) item = items[items.length - 1]  // last-item fallback when id unresolved (L-ATB1)
    if (!item) return false
    if (els.image) {
      const raw = (item.featured_image && item.featured_image.url) || item.image
      if (raw) els.image.src = raw + (raw.indexOf('?') === -1 ? '?' : '&') + 'width=300'
      els.image.alt = (item.featured_image && item.featured_image.alt) || item.product_title || ''
    }
    if (els.title)   els.title.textContent = item.product_title || item.title
    if (els.price)   els.price.innerHTML = formatMoneyHtml(item.final_price)
    // cart discount (original_price > final_price) is the only markdown the AJAX cart item carries;
    // the product-level compare_at_price is absent from the cart/add schema and is filled in async by
    // enrichProductCompare (L-ATB4).
    if (els.compare) {
      els.compare.innerHTML = item.original_price > item.final_price ? formatMoneyHtml(item.original_price) : ''
    }
    if (announce) announce.textContent = (item.product_title || '') + ' ' + (strings.addedSuffix || '')
    return item
  }

  // The AJAX cart item has no compare_at_price, so the on-sale RRP is fetched from the market-aware
  // /products/{handle}.js and shown (the greater of the variant compare-at and any cart-discount original).
  function enrichProductCompare(item) {
    if (!els.compare || !item || !item.handle) return
    const c = new AbortController()
    const t = setTimeout(() => c.abort(), 8000)
    fetch(shopRoot() + 'products/' + item.handle + '.js', { signal: c.signal })
      .then(r => { if (!r.ok) throw new Error('fetch_failed'); return r.json() })
      .then(p => {
        clearTimeout(t)
        const variant = (p.variants || []).find(v => String(v.id) === String(item.variant_id))
        const compareAt = Math.max((variant && variant.compare_at_price) || 0, item.original_price || 0)
        els.compare.innerHTML = compareAt > item.final_price ? formatMoneyHtml(compareAt) : ''
      })
      .catch(() => clearTimeout(t))
  }

  function show() {
    clearTimeout(dismissTimer)
    root.removeAttribute('aria-hidden')
    root.removeAttribute('inert')
    // Set the resting position with the transition suppressed so the appear itself
    // doesn't animate it (scroll repositions below DO animate, via the CSS translate).
    root.style.transition = 'none'
    setTopOffset()
    void root.offsetWidth
    root.style.transition = ''
    root.setAttribute('data-atb-notification-visible', '')
    restartProgress()
    dismissTimer = setTimeout(hide, DWELL)
  }

  function hide() {
    clearTimeout(dismissTimer)
    root.setAttribute('aria-hidden', 'true')
    root.setAttribute('inert', '')
    root.removeAttribute('data-atb-notification-visible')
    if (els.progress) els.progress.removeAttribute('data-atb-notification-progress-run')
  }

  function restartProgress() {
    if (!els.progress) return
    els.progress.removeAttribute('data-atb-notification-progress-run')
    void els.progress.offsetWidth  // forced reflow restarts the CSS animation
    els.progress.setAttribute('data-atb-notification-progress-run', '')
  }

  function setTopOffset() {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches
    const gutter = isDesktop ? 32 : 16
    let uspHeight = 0
    if (isDesktop) {
      const usp = document.querySelector('[data-usp-banner-init]')
      const uspRect = usp && usp.getBoundingClientRect()
      uspHeight = (uspRect && uspRect.bottom > 0) ? usp.offsetHeight : 0
    }
    // Clearance below the header WITHOUT revealing a scrolled-off one: 0 when scrolled
    // off, the header alone when sticky (bar slid off), the whole group at the top.
    const sticky = group && group.dataset.headerSticky
    let chrome
    if (sticky === 'hidden') chrome = 0
    else if (sticky === 'visible') chrome = header ? header.offsetHeight : 0
    else chrome = group ? group.offsetHeight : (header ? header.offsetHeight : 0)
    // PLP: while the filter bar is stuck it sits below the header — clear it too.
    const filterBar = document.querySelector('[data-plp-filter-bar-sticky]')
    if (filterBar && filterBar.dataset.stuck === 'true') chrome += filterBar.offsetHeight
    // --atb-top drives the resting Y in the CSS translate (GPU), so scroll repositions animate smoothly.
    root.style.setProperty('--atb-top', ((group || header) ? chrome + uspHeight + gutter : 0) + 'px')
  }

  function fetchCartAndShow(variantId, compareText) {
    const c = new AbortController()
    const t = setTimeout(() => c.abort(), 8000)
    fetch(shopRoot() + 'cart.js', { signal: c.signal, cache: 'no-store' })
      .then(r => { if (!r.ok) throw new Error('fetch_failed'); return r.json() })
      .then(cart => {
        clearTimeout(t)
        const item = populate(cart, variantId)
        if (!item) return
        show()
        // The clicked card already showed the compare-at price — use it instantly; only fetch it when
        // it wasn't on screen.
        if (compareText && els.compare) els.compare.innerHTML = compareText
        else enrichProductCompare(item)
      })
      .catch(() => { clearTimeout(t); if (errorEl) errorEl.textContent = strings.addFailed || '' })
  }

  document.addEventListener('cart:added', e => {
    // Fast path: add-to-bag.js passes the /cart/add.js line item, so render immediately without a
    // second /cart.js round-trip. Fall back to fetching the cart when no item is supplied (e.g. the PDP).
    const passed = e.detail && e.detail.item
    if (passed && passed.variant_id != null) {
      const item = populate({ items: [passed] }, resolveVariantId(e))
      if (item) {
        show()
        // The clicked card already showed the compare-at price — render it instantly. Only fall back to
        // the /products fetch when it wasn't on screen (e.g. a card whose sale price hadn't corrected yet).
        const compareText = e.detail.compareText
        if (compareText && els.compare) els.compare.innerHTML = compareText
        else enrichProductCompare(item)
      }
      return
    }
    fetchCartAndShow(resolveVariantId(e), e.detail && e.detail.compareText)
  })
  root.addEventListener('click', e => {
    if (e.target.closest('[data-atb-notification-close]'))    hide()
    if (e.target.closest('[data-atb-notification-view-bag]')) { hide(); document.dispatchEvent(new CustomEvent('mini-bag:open')) }
  })

  // Reposition to track the header-group's sticky state while the toast is on screen.
  if (group) new MutationObserver(() => {
    if (root.hasAttribute('data-atb-notification-visible')) setTopOffset()
  }).observe(group, { attributes: true, attributeFilter: ['data-header-sticky'] })

  // PLP: the filter bar's stick/unstick also shifts the toast's clearance.
  const filterBarEl = document.querySelector('[data-plp-filter-bar-sticky]')
  if (filterBarEl) new MutationObserver(() => {
    if (root.hasAttribute('data-atb-notification-visible')) setTopOffset()
  }).observe(filterBarEl, { attributes: true, attributeFilter: ['data-stuck'] })
})()
